import request from '@/utils/request';

// 查询系统日志
export function sysLogList(params) {
  return request({
    url: `/op/sysLog/pageList`,
    method: 'get',
    params: params
  });
}
// 查询系统日志
export function terminalList(params) {
  return request({
    url: `/op/sysLog/terminal`,
    method: 'get',
    params: params
  });
}
// 查询系统日志
export function columnList(params) {
  return request({
    url: `/op/sysLog/column`,
    method: 'get',
    params: params
  });
}

